export const SEARCH_USER_ACTION_REQUEST = 'SEARCH_USER_ACTION_REQUEST';
export const SEARCH_USER_ACTION_SUCCESS = 'SEARCH_USER_ACTION_SUCCESS';
export const SEARCH_USER_ACTION_FAILURE = 'SEARCH_USER_ACTION_FAILURE';

export const SEARCH_USER_ACTION_FETCH = 'SEARCH_USER_ACTION_FETCH';

export const SEARCH_USER_CLEAR_ACTION = 'SEARCH_USER_CLEAR_ACTION';
